import { Controller } from '@hotwired/stimulus'
import intlTelInput from 'intl-tel-input'
import { AsYouType } from 'libphonenumber-js'
import intlTelInputUtils from 'intl-tel-input/utils'
import { country, locale } from 'locale'
import * as intlTelInputLocales from 'intl-tel-input/locale'

export default class extends Controller {
  static targets = ['phone', 'nationalPhone']

  connect() {
    this.iti = intlTelInput(this.nationalPhoneTarget, {
      initialCountry: country,
      strictMode: true,
      separateDialCode: false,
      numberDisplayFormat: intlTelInput.NUMBER_FORMAT.NATIONAL,
      countryNameLocale: locale,
      uiTranslations: this.intlInputTranslations,
      loadUtils: () => this.intlInputUtils,
    })

    // autofill can set the value without firing input, so sync again right before the form is sent
    this.form = this.element.closest('form')
    this.form?.addEventListener('submit', this.syncPhone, { capture: true })
  }

  disconnect() {
    this.form?.removeEventListener('submit', this.syncPhone, { capture: true })
    this.iti?.destroy()
  }

  syncPhone = () => this.nationalPhoneChanged()

  nationalPhoneAutofilled() {
    this.iti.setNumber(this.nationalPhoneTarget.value)
    this.nationalPhoneChanged()
  }

  nationalPhoneChanged() {
    this.phoneTarget.value = this.iti.getNumber(
      intlTelInput.NUMBER_FORMAT.INTERNATIONAL
    )
  }

  get intlInputUtils() {
    // we extended the delfault utils behaviour because this bug
    // https://github.com/jackocnr/intl-tel-input/issues/2031
    // in case this not work for some reason, just use the default utils.
    return {
      default: {
        ...intlTelInputUtils,
        formatNumberAsYouType: (number, countryCode) =>
          new AsYouType(countryCode.toUpperCase()).input(number),
      },
    }
  }

  get intlInputTranslations() {
    return intlTelInputLocales[locale.split('-')[0]]
  }
}
